import Head from "next/head";
import { useRouter } from "next/router";
import { getMetaJson } from "@/config/meta";
import { Compatible, CompatibleMsg } from "./index.styled";
import styles from "./antd.module.scss";
import React, { useEffect, useState } from "react";
import { isSupportCss } from "@/utils";
import { FrameComponent } from "@/layout/frame";

export default function PublicLayout(props: { children: any }) {
  const { pathname } = useRouter();
  const metaJson: any = getMetaJson();
  const [supportAntd, setsupportAntd] = useState(true);
  const metaItem = metaJson[pathname] || metaJson["/"];
  const { keywords, description, title } = metaItem;

  useEffect(() => {
    setsupportAntd(isSupportCss());
  }, []);
  return (
    <>
      <Head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=yes" />
        {/* <!-- 强制Chromium内核，作用于360浏览器、QQ浏览器等国产双核浏览器 --> */}
        <meta name="renderer" content="webkit" />
        {/* <!-- 强制Chromium内核，作用于其他双核浏览器 --> */}
        <meta name="force-rendering" content="webkit" />
        {/* <!-- 如果有安装 Google Chrome Frame 插件则强制为Chromium内核，否则强制本机支持的最高版本IE内核，作用于IE浏览器 --> */}
        <meta httpEquiv="X-UA-Compatible" content="IE=Edge,chrome=1" />
        <meta httpEquiv="Content-type" content="text/html; charset=utf-8" />
        <link rel="dns-prefetch" href="//glsp-img.unipus.cn" />
        <link rel="preconnect" href="//glsp-img.unipus.cn" />
        <link rel="dns-prefetch" href="//lf1-cdn-tos.bytegoofy.com" />
        <link rel="preconnect" href="//lf1-cdn-tos.bytegoofy.com" />
        <link rel="dns-prefetch" href="//at.alicdn.com" />
        <link rel="preconnect" href="//at.alicdn.com" />

        <meta name="keywords" content={keywords} />
        <meta name="description" content={description} />
        <title>{title}</title>
      </Head>
      <div className={styles.antd}>
        {!supportAntd && (
          <Compatible>
            <CompatibleMsg>
              您的浏览器版本过低，请升级浏览器版本或使用其他浏览器访问！
            </CompatibleMsg>
          </Compatible>
        )}
        <FrameComponent {...props} />
      </div>
      <style>{`
        body {
          margin: 0;
          padding: 0;
        }
      `}</style>
    </>
  );
}
